import React from "react";
import { Route, Routes } from "react-router-dom";
import ListDocumentForOneClient from "../ListDocumentForOneClient/ListDocumentForOneClient";
import ListSalarieDocRhForOneClient from "../ListSalarieDocRhForOneClient/ListSalarieDocRhForOneClient";
import ListSalarieForOneClient from "../ListSalarieForOneClient/ListSalarieForOneClient";
import ListSimulationForOneClient from "../ListSimulationForOneCLient/ListSimulationForOneClient";
import ListMeetingForOneClient from "../Meeting/MeetingForOneClient";
import Form from "./components/Form/Form";
import ListClient from "./components/List/ListClient";

const Client = () => {
  return (
    <div className="client">
      <Routes>
        <Route path="/" exact element={<ListClient />} />
        <Route path="/new" exact element={<Form />} />
        <Route path="/edit/:id" exact element={<Form />} />
        <Route
          path="/view/salaries/:id"
          exact
          element={<ListSalarieForOneClient />}
        />
        <Route
          path="/:clientId/folder"
          exact
          element={<ListSalarieDocRhForOneClient />}
        />
        <Route
          path="/view/documents/:id"
          exact
          element={<ListDocumentForOneClient />}
        />
        <Route
          path="/:clientId/simulations"
          exact
          element={<ListSimulationForOneClient />}
        />
        <Route
          path="/:clientId/meeting"
          exact
          element={<ListMeetingForOneClient />}
        />
        <Route path="/*" exact element={<div>Erreur</div>} />
      </Routes>
    </div>
  );
};

export default Client;
